import { useId } from 'react';
import type { TimeRange } from '@/lib/types';

interface DateRangeFilterProps {
  value: TimeRange;
  onChange: (range: TimeRange) => void;
}

const dateRangeOptions: { value: TimeRange; label: string }[] = [
  { value: 'all', label: 'All Time' },
  { value: '15m', label: 'Last 15 Minutes' },
  { value: '1h', label: 'Last Hour' },
  { value: '24h', label: 'Last 24 Hours' },
  { value: '7d', label: 'Last 7 Days' },
  { value: '30d', label: 'Last 30 Days' },
];

export default function DateRangeFilter({ value, onChange }: DateRangeFilterProps) {
  const selectId = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={selectId} className="text-sm font-medium text-muted-foreground">Date Range</label>
      <select
        id={selectId}
        value={value}
        onChange={(e) => onChange(e.target.value as TimeRange)}
        className="px-3 py-2 rounded-md bg-background border border-border text-sm outline-none focus:border-primary transition-colors cursor-pointer"
      >
        {dateRangeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
